export default __webpack_public_path__ + "static/media/GR00056-morning.ecf38945.svg";